import { JsonObject, JsonProperty } from 'json2typescript';

import { Document } from './document';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { OrderDocumentInterface } from '../../../core';

@JsonObject('OrderDocument')
export class OrderDocument extends Document implements OrderDocumentInterface {
    @JsonProperty('Action_id', IdAdapter, true)
    private _selectedProductId: Id = undefined;

    get selectedProductId(): Id {
        return this._selectedProductId;
    }
}
